import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styles from "./detail.module.less";
import CommonNavBar from "../../components/CommonNavBar";
import { noticeDetail } from "api/notice";

function Detail() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const message_id = params.get("message_id");
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const result = await noticeDetail(message_id);
      setData(result.data);
    };
    fetchData();
  }, []);

  return (
    <div className={styles["detail-container"]}>
      <CommonNavBar
        title={"消息详情"}
        onClickBack={() => {
          if (params.get("isPush") === "true") {
            navigate("/main/home", { replace: true });
          } else {
            navigate(-1);
          }
        }}
      />
      <img
        className={styles["right-banner"]}
        src={require("@/images/mine/img_integration_top_bg.png")}
        alt=""
      />
      <div className={styles["content-title"]}>{data.message_title}</div>
      <div className={styles["content-info"]}>
        <div className={styles["content-info-text"]}>{data.send_time}</div>
        {/* <div className={styles["content-info-text"]}>
          浏览量：{data.read_count}
        </div> */}
      </div>
      <div
        className={styles["content-container"]}
        dangerouslySetInnerHTML={{ __html: data.message_content }}
      ></div>
    </div>
  );
}
export default Detail;
